// Order of values in below Union Types cannot change
export var progressUnionTypes = ['TIME_BOX', 'INDEFINITE', 'TIME_STAMP'];
export var commitmentUnionTypes = ['FULL_TIME', 'PART_TIME'];
export var levelUnionTypes = ['GRADUATE', 'JUNIOR', 'MID_LEVEL', 'SENIOR', 'VETERAN'];
export var responsibilityUnionTypes = ['TEAM_MEMBER', 'LEAD', 'MANAGER', 'LEADER'];
export var activityDurationUnitUnionTypes = ['DAY', 'WEEK', 'MONTH', 'YEAR'];
export var certificateUnionTypes = ['GENERAL', 'CERT_I', 'CERT_II', 'CERT_III', 'CERT_IV', 'POST_GRAD', 'POST_BAC', 'POST_MST', 'SPECIALIST'];
export var activityCategoriesUnionType = ['education', 'competition', 'employment', 'social', 'personal', 'life'];
export var prizeCategoryUnionTypes = [1, 2, 3, 4, 5, 6, 7];
export var jurisdictionUnionTypes = [1, 2, 3, 4, 5];
export var competitionPlaceUnionTypes = [0, 1, 2, 3];
export var meetupAttendeesUnionTypes = [1, 2, 3, 4, 5];
export var meetupTypesUnionTypes = [1, 2, 3];